import React, { useState } from 'react'
import UploadComponent from './uploadTab'
import AllUploaded from './allUploadedTab'
import Archive from './ArchiveTab'
import { Tabs } from 'antd'
import TabPane from 'antd/es/tabs/TabPane'
import './css/style.css'
import { useTheme } from '../../../utils/themeToggle/theme'


export default function BulkUploadTab() {
  const [activeTab, setActiveTab] = useState("1");
  const { darkMode, toggleTheme } = useTheme();

  return (
    <Tabs
      activeKey={activeTab}
      onChange={(key) => setActiveTab(key)}
      // className="custom-tabs"
      tabBarStyle={{ paddingLeft: "1.5rem" }}
    >
      <TabPane tab="Upload" key="1">
        {activeTab === "1" && <UploadComponent />}
      </TabPane>
      <TabPane tab="All Uploaded" key="2">
        {activeTab === "2" && <AllUploaded />}
      </TabPane>
      <TabPane tab="Archive" key="3">
        {activeTab === "3" && <Archive />}
      </TabPane>
    </Tabs>
  );
};
